import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <span className="left">Support: support@pairfon.com</span>
        <span className="right">© 2025 Pairfon. All Rights Reserved.</span>
      </div>
    </footer>
  );
}
